import { Container } from "react-bootstrap";
import Navigation from "../Navbar";
import config from "./config.json"

const Configuracoes = () => {
    const salvajson = () => {
        // let objSalvo = [{}];
        console.log(config.data[0]['url'])
        // Armazena no LocalStorage
        console.log(localStorage)
        localStorage.setItem('objteste', JSON.stringify(config.data[0]['url']));      
        // console.log('objSalvo: ', JSON.parse(localStorage.getItem('objteste')));   
        alert("Salvo")     
    }
    return(
        <>
            <Navigation />
            <Container>
                <div>
                    <span className="d-flex justify-content-center fs-3 text-primary">Configurações</span>
                    {/* <button onClick={() => salvajson()}>salvar</button> */}
                </div>                 
            </Container>
        </>
    )
}

export default Configuracoes;
